import React, { FC } from 'react'
import { TabPanel, TabPanels as HeadlessTabPanels } from '@headlessui/react'
import { useGiveawayContext } from '../../../context/GiveawayContext'
import { TabContent } from '../TabContent'

export const TabPanels: FC = () => {
  const { content } = useGiveawayContext()
  const tabs = content.tabsCollection?.items || []
  return (
    <HeadlessTabPanels className="w-full">
      {tabs.map((tab) => (
        <TabPanel key={tab?.sys.id} className="w-full">
          <TabContent tab={tab} />
        </TabPanel>
      ))}
    </HeadlessTabPanels>
  )
}
